/*
 * @Author: 孙兴隆
 * @description 接口文件
 */
import request from '../../../../api/index'

export default class {
  //获取系统列表
  static getSystemList = (params) => {
    return request('get', `sysmenu/index`, params)
  }
  //重置密码
  static ResetPass = (params) => {
    return request('post', `employee/reset`, params)
  }
  //启/禁用
  static ChangeStatus = (params) => {
    return request('post', `employee/updateState`, params)
  }

  // 编辑管理员
  static edit = (params) => {
    return request('GET', 'employee/edit', params)
  }

  // 保存
  static save = (params) => {
    return request('post', 'employee/save', params)
  }
}

